module.exports = __webpack_public_path__ + "img/sand-art-personalizzato.32114ff3.jpg";